import moment from 'moment';

export const currentGame = state => state.game.name;

export const currentRank = state => {
  let rank;

  switch (state.level) {
    case 1: rank = 'Szultán vagy!'; break;
    case 2: rank = 'Császár!'; break;
    case 3: rank = 'Király!'; break;
    case 4: rank = 'Sirály!'; break;
    case 5: rank = 'Ász vagy!'; break;
    case 6: rank = 'Jól nyomod!'; break;
    case 7: rank = 'Szuper játék!'; break;
    case 8: rank = 'Profi megoldás!'; break;
    case 9: rank = 'Nagy mester vagy!'; break;
    case 10: rank = 'Okos!!!'; break;
    case 11: rank = 'Meghajlunk előtted...'; break;
    case 12: rank = 'Le a kalappal!'; break;
    case 13: rank = 'Doktori fokozat!'; break;
    case 14: rank = 'Wow!!! Ezt biztos egyedül csináltad?'; break;
    default: rank = '';
  }

  return rank;
};

export const resultInSec = state => moment(new Date(0)).milliseconds(state.result).format('m:ss,SSS');
